import { useEffect, useState } from "react";
import { CURRENT_VERSION, RELEASES } from "../releases.ts";

const SEEN_KEY = "electro-planner-panels:seen-release";

/**
 * Visar releasenoter när användaren öppnar en ny version för första gången,
 * eller när användaren trycker på knappen i toolbaren.
 */
export function ReleaseNotesDialog({
  forceOpen,
  onClose,
}: {
  forceOpen?: boolean;
  onClose?: () => void;
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (forceOpen) {
      setOpen(true);
      return;
    }
    if (typeof window === "undefined") return;
    const seen = window.localStorage.getItem(SEEN_KEY);
    if (seen !== CURRENT_VERSION) setOpen(true);
  }, [forceOpen]);

  const close = () => {
    setOpen(false);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(SEEN_KEY, CURRENT_VERSION);
    }
    onClose?.();
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50"
      onClick={close}
      role="dialog"
    >
      <div
        className="max-h-[80vh] w-full max-w-lg overflow-auto rounded-lg bg-white p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold">Nytt i Centralspec</h2>
          <button
            type="button"
            onClick={close}
            className="rounded px-2 py-1 text-slate-500 hover:bg-slate-100"
            aria-label="Stäng"
          >
            ×
          </button>
        </div>
        <div className="space-y-4">
          {RELEASES.map((r) => (
            <section key={r.version}>
              <header className="mb-1 flex items-baseline gap-2">
                <span className="font-mono text-sm font-semibold">
                  v{r.version}
                </span>
                <span className="text-xs text-slate-500">{r.date}</span>
              </header>
              {r.title ? (
                <p className="mb-1 font-medium">{r.title}</p>
              ) : null}
              <ul className="list-disc space-y-1 pl-5 text-sm text-slate-700">
                {r.items.map((i, idx) => (
                  <li key={idx}>{i}</li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
